// @flow

type SizeName =
  | 'ms' // mobile small
  | 'mm' // mobile medium
  | 'ml' // mobile large
  | 'ts' // tablet small
  | 'ls' // laptop small
  | 'lm' // laptop medium
;
export const mediaSize: {[SizeName]: number} = {
  ms: 320,
  mm: 375,
  ml: 425,
  ts: 768,
  ls: 1024,
  lm: 1440,
};

export function inPixels(sizeName: SizeName): number {
  return mediaSize[sizeName];
}
